import { Pipe, PipeTransform } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: 'collection'
})
export class CollectionPipe implements PipeTransform {
  constructor(private afs: AngularFirestore) {}

  transform(value: any): Observable<any> {
    return this.afs.collection<any>(value.path).valueChanges();
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/shared/pipes/collection.pipe.ts